import UpdateLessonActivities from './UpdateLessonActivities';


export function LessonActivities() {
  return (
        <UpdateLessonActivities/>
  )
}
export default LessonActivities
